import { $t } from "@klondpay/locales";
const Layout = () => import("/@/layout/index.vue");

const accountCenterRouter = {
  path: "/account-center",
  component: Layout,
  redirect: "/account-center/user",
  meta: {
    icon: "account-center",
    title: $t("menus.user"),
    rank: 12,
    authority: [
      "acquirer.user",
      "acquirer.role",
      "acquirer.merchant.role.1",
      "acquirer.merchant.user.2"
    ]
  },
  children: [
    {
      path: "/account-center/user",
      name: "AccountCenterUser",
      component: () => import("/@/views/account-center/user-new/index.vue"),
      meta: {
        // icon: "account-center",
        title: $t("机构用户"),
        keepAlive: true,
        showParent: true,
        authority: ["acquirer.user"]
      },
      children: [
        {
          path: "/account-center/user/add",
          name: "AccountCenterUserAdd",
          component: () => import("/@/views/account-center/user-new/Add.vue"),
          meta: {
            title: $t("新增用户"),
            keepAlive: true,
            showLink: false,
            authority: ["acquirer.user"]
          }
        },
        {
          path: "/account-center/user/edit",
          name: "AccountCenterUserEdit",
          component: () => import("/@/views/account-center/user-new/Add.vue"),
          meta: {
            title: $t("编辑用户"),
            keepAlive: true,
            showLink: false
          }
        },
        {
          path: "/account-center/user/detail",
          name: "AccountCenterUserDetail",
          component: () =>
            import("/@/views/account-center/user-new/detail.vue"),
          meta: {
            title: $t("用户详情"),
            keepAlive: true,
            showLink: false
          }
        }
      ]
    },
    {
      path: "/account-center/role",
      name: "AccountCenterRole",
      component: () => import("/@/views/account-center/role-new/index.vue"),
      meta: {
        // icon: "role-admin",
        title: $t("机构角色"),
        showParent: true,
        authority: ["acquirer.role"]
      },
      children: [
        {
          path: "/account-center/role/add",
          name: "AccountCenterRoleAdd",
          component: () => import("/@/views/account-center/role-new/Edit.vue"),
          meta: {
            title: $t("新增角色"),
            keepAlive: true,
            showLink: false
          }
        },
        {
          path: "/account-center/role/edit",
          name: "AccountCenterRoleEdit",
          component: () => import("/@/views/account-center/role-new/Edit.vue"),
          meta: {
            title: $t("编辑角色"),
            keepAlive: true,
            showLink: false
          }
        }
      ]
    },

    {
      path: "/account-center/merchant-user",
      name: "AccountCenterUserMerchant",
      component: () =>
        import("/@/views/account-center/user-merchant/index.vue"),
      meta: {
        // icon: "account-center",
        title: $t("商户用户"),
        keepAlive: true,
        showParent: true,
        authority: ["acquirer.merchant.user.2"]
      },
      children: [
        {
          path: "/account-center/merchant-user/add",
          name: "AccountCenterUserMerchantAdd",
          component: () =>
            import("/@/views/account-center/user-merchant/Add.vue"),
          meta: {
            title: $t("新增用户"),
            keepAlive: true,
            showLink: false,
            authority: ["acquirer.user"]
          }
        },
        {
          path: "/account-center/merchant-user/edit",
          name: "AccountCenterUserMerchantEdit",
          component: () =>
            import("/@/views/account-center/user-merchant/Add.vue"),
          meta: {
            title: $t("编辑用户"),
            keepAlive: true,
            showLink: false
          }
        },
        {
          path: "/account-center/merchant-user/detail",
          name: "AccountCenterUserMerchantDetail",
          component: () =>
            import("/@/views/account-center/user-merchant/detail.vue"),
          meta: {
            title: $t("用户详情"),
            keepAlive: true,
            showLink: false
          }
        }
      ]
    },
    {
      path: "/account-center/merchant-role",
      name: "AccountCenterRoleMerchant",
      component: () =>
        import("/@/views/account-center/role-merchant/index.vue"),
      meta: {
        // icon: "role-admin",
        title: $t("商户角色"),
        showParent: true,
        authority: ["acquirer.merchant.role.1"]
      },
      children: [
        {
          path: "/account-center/merchant-role/add",
          name: "AccountCenterRoleMerchantAdd",
          component: () =>
            import("/@/views/account-center/role-merchant/Edit.vue"),
          meta: {
            title: $t("新增角色"),
            keepAlive: true,
            showLink: false
          }
        },
        {
          path: "/account-center/merchant-role/edit",
          name: "AccountCenterRoleMerchantEdit",
          component: () =>
            import("/@/views/account-center/role-merchant/Edit.vue"),
          meta: {
            title: $t("编辑角色"),
            keepAlive: true,
            showLink: false
          }
        }
      ]
    }
  ]
};

export default accountCenterRouter;
